import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {toCapitalize} from "./utils";
import {useAuthConfig} from "./helper";
import { getOptionSelectedByField } from './utils/autocompleteUtils';

export const UserSearch = ({defValue, onOptionsChange, rowID = -1}) => {
    let authAxios = useAuthConfig();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const processSearchName = data => {
        const updatedList = []
        data.forEach((item) => {
            const searchHelperObj = {description: `${item.lastName},${item.firstName}-${item.racfID}`}
            item = {...item, ...searchHelperObj};
            updatedList.push(item)
        });
        setOptions(updatedList)
    }

    const getPeople = async (value) => {
        setLoading(true)
        try {
            await authAxios.get(`/user/search?searchStr=${value}`).then(res => {
                processSearchName(res.data)
                setLoading(false)
            })
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    };

    const handleClose = () => {
        setOptions([])
    }

    return (
        <Autocomplete
            fullWidth
            size="small"
            id="people-find"
            options={options}
            defaultValue={defValue}
            value={defValue}
            getOptionLabel={(option) => option.racfID ? `${option.lastName && toCapitalize(option.lastName)}, ${option.firstName && toCapitalize(option.firstName)} - ${option.racfID}` : ""}
            getOptionSelected={getOptionSelectedByField('racfID')}
            loading={loading}
            onClose={handleClose}
            onChange={(e, value) => {
                onOptionsChange(value, rowID)
            }}
            onInputChange={(e, value) => {
                if (e && e.type === 'change' && value.length > 2)
                    getPeople(value)
            }}
            renderInput={(params) => <TextField {...params}
                                                placeholder="Search By Last Name or User ID"
                                                variant="outlined"/>}
        />
    );
}
